import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import FarmParcels from "./index";
import ViewFarmParcel from "./view";
import EditFarmParcel from "./edit";

const farmParcelRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Farm Parcels",
		basePath: "farmer-informations/:farmerinformationId/farm-parcels",
		mainComponent: <FarmParcels />,
	    layout: "/console",	   
	    subTitle:"Farm Parcel",
	    viewComponent: <ViewFarmParcel />,
	    createComponent: <EditFarmParcel />,
	    editComponent: <EditFarmParcel />,
		isMainMenu:false,
	})
]

export default farmParcelRoutes;